export const navList=[
{
    href:'#daska',
    text:'tehnika_izrade'
},
{
    href:'#slavskeIkone',
    text:'slavske_ikone'
},
{
    href:'#kompozicije',
    text:'kompozicije'
},
{
    href:'#diptisi',
    text:'diptisi'
}
]